import { CourseEntity } from '@/graphql/generated/graphql';
import { GAEvent } from './events';
import { pushDataLayer } from './utils';

type CourseData = {
  course_id: string;
};

export const trackCourseOpen = async (course: Partial<CourseEntity>) => {
  const param = {
    course_id: course.id!,
  };

  pushDataLayer<CourseData>(GAEvent.COURSE_OPEN, param);
};

export const trackCourseCompleted = async (course: Partial<CourseEntity>) => {
  const param = {
    course_id: course.id!,
  };

  pushDataLayer<CourseData>(GAEvent.COURSE_COMPLETED, param);
};
